import * as React from 'react';
export const noteSvg = React.forwardRef(function noteSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M4 9.75A.75.75 0 0 1 4.75 9h2a.75.75 0 0 1 0 1.5h-2A.75.75 0 0 1 4 9.75ZM4.75 5a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5h-6Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M1 12.5v-9A2.5 2.5 0 0 1 3.5 1h9A2.5 2.5 0 0 1 15 3.5v6.672a2 2 0 0 1-.586 1.414l-2.828 2.828a2 2 0 0 1-1.414.586H3.5A2.5 2.5 0 0 1 1 12.5Zm1.5 0v-9a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v5h-3.25a1.75 1.75 0 0 0-1.75 1.75v3.25h-5a1 1 0 0 1-1-1Zm7.5 1h.172a.5.5 0 0 0 .353-.146l2.829-2.829a.5.5 0 0 0 .146-.353V10h-3.25a.25.25 0 0 0-.25.25v3.25Z',
    }),
  );
});
noteSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var note = {
  category: 'icon',
  colorable: true,
  name: 'note',
  svg: noteSvg,
};
